<template>
  <div class="container">
    <div class="row">
      <div id="step2" class="col-xs-12 text-center">
        <registration-progress-bar
          title-reg="What best describes your purchase"
          progress="60"
        ></registration-progress-bar>
        <br />
        <div class="row">
          <div class="col-sm-6">
            <h4>Organization</h4>
            <p style="min-height: 100px">
              Choose this option if you’re are purchasing subscriptions on
              behalf of an organization, have a different billing entity than
              the end-user, or if there may be multiple subscriptions purchased
              with this account.
            </p>
            <p>
              <button
                id="step3Org"
                type="button"
                class="btn btn-primary btn-block"
                @click.prevent="nextStep('business')"
              >
                Buying for an organization
              </button>
            </p>
          </div>

          <div class="col-sm-6">
            <h4>Individual</h4>
            <p style="min-height: 100px">
              Choose this option if you are a sole individual purchasing a
              single subscription for your own personal use. Don't worry, you
              can purchase additional licenses with this account in the future
              should you so choose.
            </p>
            <p>
              <button
                id="step3Person"
                type="button"
                class="btn btn-primary btn-block"
                @click.prevent="nextStep('personal')"
              >
                Buying for myself
              </button>
            </p>
          </div>
        </div>
        <br />
        <next-prev-buttons></next-prev-buttons>
      </div>
    </div>
    <scroll></scroll>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("resetNpiSearchResults");
  },
  methods: {
    nextStep(formType) {
      this.$store.dispatch("nextStep");
      this.$store.dispatch("setFormType", formType);
    },
  },
};
</script>
